import replaceCurrency from './replace-currency';

const addSortableAttributes = (options) => {
  const { sortableAttributes, sortByAttribute, ...others } = options;

  if (!sortableAttributes) {
    return others;
  }

  const sortableAttribute = sortableAttributes[sortByAttribute];
  if (!sortableAttribute) {
    console.warn(`sortableAttributes do not contain ${sortByAttribute}`);
    return others;
  }

  const defaultOrder = sortableAttribute.order;

  const newSortableAttributes = {};
  Object.entries(sortableAttributes).forEach(([name, attr]) => {
    newSortableAttributes[`${name}_asc`] = {
      ...attr,
      label: `${attr.label} aufsteigend`,
      order: 'asc',
    };
    newSortableAttributes[`${name}_desc`] = {
      ...attr,
      label: `${attr.label} absteigend`,
      order: 'desc',
    };
  });


  return {
    ...others,
    sortByAttribute: `${sortByAttribute}_${defaultOrder}`,
    sortableAttributes: newSortableAttributes,
  };
};

const addVisualizerDependentOption = (options, clientDataVisualizer) => {
  switch (clientDataVisualizer) {
    case 'HierarchyVisualizer':
      return { compareToTotal: true, ...options };
    case 'TresholdVisualizer':
      return { showThresholdOnly: false, ...options };
    case 'TableVisualizer':
      return { canExport: true, ...options };
    default:
      return options;
  }
};

const prepareVisualizerOptions = (visualizerOptionsString, clientDataVisualizer, currencySymbol) => {
  const visualizerOptionsObject = JSON.parse(replaceCurrency(visualizerOptionsString, currencySymbol));

  return addVisualizerDependentOption(
    addSortableAttributes({ ...visualizerOptionsObject, currencySymbol }), clientDataVisualizer,
  );
};

export default prepareVisualizerOptions;
